'use client';
import { FC } from 'react';
import { SelectedEquipmentInfo as SelectedEquipmentInfoType } from 'app/[lang]/[esite]/(core)/_header/components/equipment-widget/types';
import { EditEquipmentDrawerHeader } from './edit-equipment-drawer-header';
import { EditEquipmentDrawerWrapper } from './edit-equipment-drawer-wrapper';
import { SelectedEquipmentInfo } from '../selected-equipment/selected-equipment-info';
import { SerialEquipmentSearchDescription } from './serial-equipment-search-description';
import { EditEquipmentDrawerForm } from './edit-equipment-drawer-form';
import { WIDGET_IDENTIFIER } from '../constants';
import styles from './edit-equipment-drawer.module.scss';
import { getFamilyName } from 'services/equipment/utils';
export interface EditEquipmentDrawerClientProps {
  selectedEquipmentInfo: SelectedEquipmentInfoType;
  isLoggedIn: boolean;
}

export const EditEquipmentDrawerClient: FC<EditEquipmentDrawerClientProps> = ({
  selectedEquipmentInfo,
  isLoggedIn
}) => {
  const {
    serialNumber,
    assetId,
    assetName,
    productFamily,
    model,
    imageURL,
    productId,
    name
  } = selectedEquipmentInfo;
  const familyName = getFamilyName(model, name ?? productFamily);
  const selectedEquipmentInfoModified = {
    productId,
    serialNumber,
    imageURL,
    equipmentFamily: familyName,
    model,
    assetId,
    assetName
  };
  return (
    <EditEquipmentDrawerWrapper
      currentEquipment={selectedEquipmentInfo}
      isLoggedIn={isLoggedIn}
    >
      <EditEquipmentDrawerHeader />
      <SelectedEquipmentInfo
        currentEquipment={selectedEquipmentInfoModified}
        identifier={WIDGET_IDENTIFIER.EDIT}
      />
      <hr className={`${styles['hr--border']} mx-n3`} />
      <SerialEquipmentSearchDescription />
      <EditEquipmentDrawerForm
        selectedEquipmentInfo={selectedEquipmentInfoModified}
      />
    </EditEquipmentDrawerWrapper>
  );
};
